import api from './api';

export const salesServiceOrderService = {
  async getFormData(pointOfSaleId = null) {
    const response = await api.get('/ventas/service-orders/form-data', {
      params: pointOfSaleId ? { point_of_sale_id: pointOfSaleId } : undefined,
    });
    return response.data;
  },

  async getServiceOrders(params = {}) {
    const response = await api.get('/ventas/service-orders', { params });
    return response.data;
  },

  async getServiceOrder(id) {
    const response = await api.get(`/ventas/service-orders/${id}`);
    return response.data;
  },

  async createServiceOrder(data) {
    const response = await api.post('/ventas/service-orders', data);
    return response.data;
  },

  async updateServiceOrder(id, data) {
    const response = await api.put(`/ventas/service-orders/${id}`, data);
    return response.data;
  },

  async toggleStatus(id) {
    const response = await api.delete(`/ventas/service-orders/${id}`);
    return response.data;
  },
};

export default salesServiceOrderService;
